import { apiClient } from '../../client'
import endpoints from '../../endpoints'
import { unwrapPaginated, type Paginated } from '../../normalize'
import type { AssignedFarm, AssignedFarmsQuery } from '../../../../types/apiModels'

export default async function getAssignedFarms({
  query,
  signal,
}: {
  query: AssignedFarmsQuery
  signal?: AbortSignal
}): Promise<Paginated<AssignedFarm>> {
  const { search, programId, hubId, contractStatus, page, size, sort } = query
  const params: Record<string, string | number> = { page, size, sort }
  if (search && search.trim()) params.search = search.trim()
  if (programId !== undefined) params.programId = programId
  if (hubId !== undefined) params.hubId = hubId
  if (contractStatus !== undefined) params.contractStatus = contractStatus

  const response = await apiClient.get(endpoints.v2.farms.list, { params, signal })
  return unwrapPaginated<AssignedFarm>(response)
}
